/** Mirrors src/domain/lineKind.ts for the PWA (separate tsconfig). */
export type LineKind = 'day_rate' | 'fixed_fee' | 'expense';

export function isLineKind(v: unknown): v is LineKind {
  return v === 'day_rate' || v === 'fixed_fee' || v === 'expense';
}

export function showsDuration(kind: LineKind): boolean {
  return kind === 'day_rate';
}

export function requiresSite(kind: LineKind): boolean {
  return kind === 'day_rate' || kind === 'fixed_fee';
}

export function requiresWorkDate(kind: LineKind): boolean {
  return kind === 'day_rate' || kind === 'fixed_fee';
}

export function usesDirectAmount(kind: LineKind): boolean {
  return kind === 'fixed_fee' || kind === 'expense';
}
